import React, { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { FormikTextField } from 'formik-material-fields';
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router-dom';
import { dataService } from '../../services/data/data.service';
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha
} from 'react-google-recaptcha-v3';


export default function LoginPage(props) {
    const navigate = useNavigate()
    console.log('LoginPage')
    useEffect(() => {
        if (props.user.loggedIn) {
            navigate('/');
        }
    }, [navigate, props.user.loggedIn])

    const classes = useStyles();
    const auth = getAuth();
    const [forgotPasswordStatus, setForgotPassword] = useState(false);
    const [returnToLogin, setReturnToLogin] = useState(false);
    const [token, setToken] = useState();
    const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
    const [recaptchaKey, setRecaptchaKey] = useState(null);

    const onVerify = (token) => {
        setToken(token);
    };
    useEffect(() => {

        if (window.location.origin.includes('localhost')) {
            setRecaptchaKey("6Ldv_QAhAAAAAPrqEEaqzMmwTe6mIMxT-8XhBi7f");

        } else {
            dataService.getSystemParameters().then(results => {
                setRecaptchaKey(results.data.find(x => x.name === "RecaptchaKey").value);
            });
        }
    });

    const doSomething = () => {
        /* do something like submit a form and then refresh recaptcha */
        setRefreshReCaptcha(r => !r);
    }
    const submitLoginForm = ({ email, password }, { setStatus, setSubmitting }) => {

        setStatus();
        setSubmitting(true);
        signInWithEmailAndPassword(auth, email, password)

            .then((userCredential) => {
                // // Signed in 
                const logidin = userCredential.user;
                dataService.infoByEmail(email).then(emailResult => {
                    if (emailResult) {
                        if (emailResult.ok) {
                            navigate('/');
                            props.actions.login(emailResult.data.username, emailResult.data.id, emailResult.data.roles)
                            dataService.loginNodeRED(emailResult.data);
                        } else {
                            // Show feedback api
                            props.actions.logout();
                            setStatus(emailResult.error);
                            setSubmitting(false);
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                });

            }).catch((error) => {
                const errorCode = error.code;
                if (errorCode === 'auth/wrong-password' || errorCode === 'auth/invalid-email') {
                    setStatus('Incorrect email of wachtwoord');

                }
                setSubmitting(false);

                const errorMessage = error.message;

            });

    };

    const submitForgotPasswordForm = ({ email }, { setStatus, setSubmitting }) => {

        const auth = getAuth();
        sendPasswordResetEmail(auth, email)
            .then(() => {
                // Password reset email sent!
                // ..
                toast.success('Check je mailbox voor een reset-mail!', { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                setSubmitting(false);
                setForgotPassword(false);
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
            });
    }
    const handleForgotPassword = () => {
        setForgotPassword(true);
    };

    return <div className={classes.background}>
        <div className="spacer100" style={{ height: "170px" }}></div>
        {forgotPasswordStatus === false ?

            <Formik
                initialValues={{
                    email: '',
                    password: ''
                }}
                validationSchema={Yup.object().shape({
                    email: Yup.string().required('Email is verplicht').email('Geen correct emailadres'),
                    password: Yup.string().required('Wachtwoord is verplicht')
                })}
                onSubmit={submitLoginForm}>
                {({ errors, status, touched, isSubmitting }) => {
                    return (
                        <React.Fragment>
                            <img className={classes.img} alt={process.env.PUBLIC_URL + '/img/Wasteware_ac_1b.png'} src={process.env.PUBLIC_URL + '/img/Wasteware_ac_1b.png'}></img>
                            <div className={classes.signUpContainer}>
                                <div className={classes.signUpHeader} >
                                    <div className={classes.signUpHeaderTitle}>
                                        {'Login'}
                                    </div>
                                    <div className={classes.signUpHeaderSubTitle}>
                                        {'Vul uw inlog gegevens hier in:'}
                                    </div>
                                </div>
                                {status &&
                                    <div className={classes.validationFeedback}>{status}</div>
                                }
                                <div className={classes.signUpFormContainer}>
                                    <Form>
                                        <div className={classes.label}>Email</div>
                                        <div className="form-group">
                                            <FormikTextField
                                                id="outlined-search"
                                                type="search"
                                                name="email"
                                                size="small"
                                                fullWidth
                                                className={classes.uiTextField}
                                            />
                                        </div>
                                        <div className={classes.passwordDiv}>
                                            <div className={classes.label}>Wachtwoord</div>
                                            <span className={classes.forgotPassword} onClick={() => handleForgotPassword()}>Wachtwoord vergeten?</span>
                                        </div>

                                        <div className="form-group">
                                            <FormikTextField
                                                id="outlined-search"
                                                type="password"
                                                name="password"
                                                size="small"
                                                fullWidth
                                                className={classes.uiTextField}
                                            />
                                        </div>
                                        <div className={classes.loginButtonContainer}>
                                            <button fullWidth variant="contained" type="submit" className={classes.loginButton} disabled={isSubmitting}>
                                                {isSubmitting ?
                                                    <div className={classes.centeredContent}>
                                                        <img alt='loading' src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                                    </div> : <div className="whiteText">{'LOGIN'}</div>
                                                }
                                            </button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </React.Fragment>
                    )
                }}
            </Formik>
            :
            <Formik
                initialValues={{
                    email: '',
                }}
                validationSchema={Yup.object().shape({
                    email: Yup.string().required('Email is verplicht'),
                })}
                onSubmit={submitForgotPasswordForm}>
                {({ errors, status, touched, isSubmitting }) => {
                    return (
                        <React.Fragment>
                            <img className={classes.img} alt={process.env.PUBLIC_URL + '/img/Wasteware_ac_1b.png'} src={process.env.PUBLIC_URL + '/img/Wasteware_ac_1b.png'}></img>
                            <div className={classes.signUpContainer}>
                                <div className={classes.signUpHeader} >
                                    <div className={classes.signUpHeaderTitle}>
                                        {'Reset je wachtwoord'}
                                    </div>
                                    <div className={classes.signUpHeaderSubTitle}>
                                        {'Vul uw emailadres in voor de reset-mail:'}
                                    </div>
                                </div>
                                {status &&
                                    <div className={classes.validationFeedback}>{status}</div>
                                }
                                <div className={classes.signUpFormContainer}>
                                    <Form>
                                        <div className={classes.label}>Gebruikersnaam</div>
                                        <div className="form-group">
                                            <FormikTextField
                                                id="outlined-search"
                                                type="search"
                                                name="email"
                                                size="small"
                                                fullWidth
                                                className={classes.uiTextField}
                                            />
                                        </div>
                                        <GoogleReCaptchaProvider
                                            reCaptchaKey={recaptchaKey}
                                            language="Dutch"


                                        >
                                            <GoogleReCaptcha
                                                onVerify={onVerify}
                                                refreshReCaptcha={refreshReCaptcha}
                                            />        </GoogleReCaptchaProvider>

                                        <div className={classes.loginButtonContainer}>
                                            <button fullWidth variant="contained" type="submit" className={classes.loginButton} disabled={isSubmitting}>
                                                {isSubmitting ?
                                                    <div className={classes.centeredContent}>
                                                        <img alt='loading' src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                                    </div> : <div className="whiteText">{'VERSTUUR EMAIL'}</div>
                                                }
                                            </button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </React.Fragment>
                    )
                }}
            </Formik>
        }
    </div>
}

const useStyles = makeStyles({

    background: {
        height: '100vh',
    },
    signUpContainer: {
        width: '500px !important',
        margin: 'auto',
        backgroundColor: '#F6F6F6',
        borderRadius: '5px',
        paddingRight: "60px",
        paddingLeft: "60px",
        paddingBottom: "30px",
        paddingTop: "50px",
        boxShadow: "0 0 15px 5px rgba(0,0,0,0.15)",
    },

    signUpHeader: {
        height: '80px',
    },
    img: {
        width: "350px",
        position: "relative",
        top: "40px"
    },

    signUpHeaderTitle: {
        paddingTop: '8px',
        color: "#020100",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        marginBottom: "5px",
        textAlign: "left"
    },
    signUpHeaderSubTitle: {
        color: "#8D8D8D",
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "left"
    },

    signUpFormContainer: {

    },

    centeredContent: {
        justifyContent: 'center',
        alignContent: 'center'
    },

    loginButton: {
        height: "40px !important",
        width: "160px",
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: "#1F8FA5",
        border: "none",
        outline: "none",
        cursor: "pointer"
    },

    loginButtonContainer: {
        width: "100%",
        textAlign: "center",
        marginTop: "5px"
    },

    uiTextField: {
        width: "97%",
        height: "40px",
        borderRadius: "5px",
        backgroundColor: "white",
        border: "1px solid #c1c2be",
        paddingLeft: "10px",
        "& .MuiInput-root": {
            height: "40px",
        },
        "& .MuiInput-underline:before": {
            borderBottom: "none !important"
        },
        "& .MuiInput-underline:after": {
            borderBottom: "none !important"
        },
        "& .MuiFormHelperText-root.Mui-error": {
            marginTop: "10px",
            height: "20px",
            backgroundColor: "rgb(1,1,1,0)",
            display: 'block'
        },
        marginBottom: "20px"
    },

    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        textAlign: "left"
    },

    smart: {
        display: 'block',
        fontSize: "26px",
        fontFamily: "Campton-bold",
        color: "#4654FF",
        height: "23px",
        marginTop: "5px",
        width: "100%",
        marginLeft: "90px",
        position: "relative",
        bottom: "30px",
        letterSpacing: "-1"
    },
    production: {
        display: 'block',
        fontSize: "26px",
        fontFamily: "Campton-bold",
        color: "#000000",
        height: "23px",
        width: "100%",
        marginLeft: "90px",
        position: "relative",
        bottom: "30px",
        letterSpacing: "-1"
    },
    authenticationErrorMessage: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        color: "#F90829",
        textAlign: "center",
    },
    validationFeedback: {
        marginLeft: "5%",
        marginBottom: "10px",
        color: "red",
        fontWeight: 400,
        width: "90%"
    },
    passwordDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        textDecoration: 'none !important'
    },
    forgotPassword: {
        color: '#1F8FA5',
        cursor: 'pointer'
    }

});